// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Notice_wrapper__1VCIR","title":"Notice_title__2pDwf","other":"Notice_other__2fuv5"};